import ApiClient from "../client";
import { PaginatedResponse } from "../types";
import {
  ApiUserProfile,
  // ApiCreateCompetitionProfilePayload,
} from "../types/profiles";

export const getMeProfile = (client: ApiClient) => {
  return client.get<ApiUserProfile>("/profiles/me");
};

export const getProfile = (client: ApiClient, uuid: string) => {
  return client.get<ApiUserProfile>(`/profiles/${uuid}`);
};

type SignalOpts = {
  signal: AbortSignal;
};

export const searchProfiles = (
  client: ApiClient,
  search: string,
  opts?: SignalOpts
) => {
  return client.get<PaginatedResponse<ApiUserProfile>>(
    `/profiles?search_q=${encodeURIComponent(search)}`,
    {
      signal: opts?.signal,
    }
  );
};

// export const createCompetitionProfile = (
//   client: ApiClient,
//   payload: ApiCreateCompetitionProfilePayload
// ) => {
//   return client.post<ApiUserProfile>("/profiles/create-competition");
// };

export const endpoints = { getMeProfile, getProfile, searchProfiles };
